// extracted by mini-css-extract-plugin
module.exports = {"container":"Search_container__1ATIJ"};